import React from "react";

export default class Unconsciousness extends React.Component {
  render() {
    return (
      <>
        <h3>Symptoms:</h3>
        <p>A person is breathing, but is not conciouss. </p>
        <h3>What to do?</h3>
        <ul>
          <li>
            Take care of your own safety and of your sorroundings (remove
            dangerous items from vicinity, pieces of glass, make sure nothing
            and noone is endangering you).{" "}
          </li>
          <li>
            The found person lie down in a safe postion (on a side) with head
            slighly pulled back.{" "}
          </li>
          <li>
            Take care of her/his thermic comfort and keep the person warm with
            the help of blankets etc. Make sure, that the person is not laying
            on bare ground (isolate from the ground with
            blanket/cardboard/jacket).{" "}
          </li>
          <li>
            Observe breathing and every 2 minutes check for life functions. - If
            the person wakes up and asks do not give food, if wants to drink,
            make sure it's without gas.{" "}
          </li>
          <li>
            If is not breathing, call a medical rescue team and immiedietly
            begin cardiovascular resuscitation (see CARDIAC ARREST)
          </li>
        </ul>
      </>
    );
  }
}
